import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const PRODUCT_MENU: PermissionTableRowType = {
  name: '상품',
  key: 'PRODUCT_MANAGE',
  subRows: [
    {
      name: '상품 관리',
      key: PERMISSION_SUBJECTS.PRODUCT,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
        PERMISSION_ACTIONS.DELETE,
        PERMISSION_ACTIONS.DOWNLOAD_EXCEL,
      ],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.PRODUCT,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '상품 상세조회',
          key: PERMISSION_SUBJECTS.PRODUCT,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '상품 등록',
          key: PERMISSION_SUBJECTS.PRODUCT,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '상품 편집',
          key: PERMISSION_SUBJECTS.PRODUCT,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
        {
          name: '상품 삭제',
          key: PERMISSION_SUBJECTS.PRODUCT,
          permissions: [PERMISSION_ACTIONS.DELETE],
        },
        {
          name: '상품 엑셀 다운로드',
          key: PERMISSION_SUBJECTS.PRODUCT,
          permissions: [PERMISSION_ACTIONS.DOWNLOAD_EXCEL],
        },
      ],
    },
  ],
};
